export type WaterMetric = 'temperature' | 'ph' | 'oxygen' | 'redox' | 'salinity';
export type SensorTarget = { min: number; max: number | null; label: string };
export type ConfiguredSensorTargets = Partial<Record<WaterMetric, { min?: number | null; max?: number | null }>>;
const defaults: Record<WaterMetric,{min:number;max:number|null;unit:string}> = {
  temperature:{min:18,max:22,unit:'°C'}, ph:{min:7,max:8.2,unit:'pH'},
  oxygen:{min:6,max:null,unit:'mg/L'},redox:{min:250,max:400,unit:'mV'},salinity:{min:28,max:37,unit:'PSU'},
};
export function configuredSensorTarget(metric:WaterMetric,targets?:ConfiguredSensorTargets|null):SensorTarget {
  const base=defaults[metric],configured=targets?.[metric];
  let min=configured?.min ?? base.min;
  let max=configured && configured.max!==undefined?configured.max:base.max;
  if(!Number.isFinite(min)||(max!==null&&(!Number.isFinite(max)||max<min))){min=base.min;max=base.max;}
  return {min,max,label:max===null?`≥ ${min} ${base.unit}`:`${min}–${max} ${base.unit}`};
}
export function withinSensorTarget(value:number|null|undefined,target:SensorTarget):boolean|undefined {
  if(value==null || !Number.isFinite(value))return undefined;
  return value>=target.min && (target.max===null || value<=target.max);
}
